module.exports = __webpack_public_path__ + "assets/apache.86e14f09.svg";